import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { apaTheme } from "../../constants/theme"; 

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  return <MuiThemeProvider theme={apaTheme.muiTheme}>{children}</MuiThemeProvider>;
};
